import { useSelector } from "react-redux";
import Svg from "../components/figs/Svg";
import PageName from "../components/PageName";
import { useNavigate } from "react-router";
import HeaderLogo from "../components/HeaderLogo";

export default function Welcome() {
  const { msg } = useSelector((state) => state.language);
  const navigate = useNavigate();

  return (
    <div className="page_welcome">
      <div className="_main_bg"></div>
      <HeaderLogo />
      <section>
        <PageName titleName={msg.welcome} />
        <div className="menu">
          <span onClick={() => navigate("/report")}>
            <Svg iconName={"report"} />
            <p>{msg.report}</p>
          </span>
          <span onClick={() => navigate("/date_management")}>
            <Svg iconName={"date_management"} />
            <p>{msg.date_management}</p>
          </span>
          <span onClick={() => navigate("/data_entry")}>
            <Svg iconName={"data_entry"} />
            <p>{msg.data_entry}</p>
          </span>
          <span onClick={() => navigate("/data_edit")}>
            <Svg iconName={"data_edit"} />
            <p>{msg.data_edit}</p>
          </span>
          <span onClick={() => navigate("/boat_settings")}>
            <Svg iconName={"boat_settings"} />
            <p>{msg.boat_settings}</p>
          </span>
          <span onClick={() => navigate("/tour_management")}>
            <Svg iconName={"tour_management"} />
            <p>{msg.tour_management}</p>
          </span>
          <span onClick={() => navigate("/organization_settings")}>
            <Svg iconName={"organization_settings"} />
            <p>{msg.organization_settings}</p>
          </span>
        </div>
      </section>
    </div>
  );
}
